import { loadExternalFiles } from './utils/startup.utils.ts';
import ReactDOM from 'react-dom/client';
import { App } from './app.tsx';
import { ChakraProvider } from '@chakra-ui/react';
import { falconTheme } from './utils/theme.utils.ts';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { environment } from './utils/env.utils.ts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

loadExternalFiles();

console.log({
    coreBaseUrl: environment.coreBaseUrl,
    crmsBaseUrl: environment.crmsBaseUrl,
    clientId: environment.clientId,
});

root.render(
    <ChakraProvider theme={falconTheme}>
        <GoogleOAuthProvider clientId={environment.clientId!}>
            <App />
            <ToastContainer />
        </GoogleOAuthProvider>
    </ChakraProvider>
);
